import { type ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';
import HighlightCarousel from '~/components/HighlightCarousel';

type CarouselProps = {
  items: ArticleCardType[];
};

type SlideContentProps = {
  item: ArticleCardType;
};

function SlideContent({ item }: SlideContentProps) {
  return (
    <ArticleCard
      className="block aspect-[4/5] size-full w-[80vw] md:h-[570px] md:w-[456px]"
      item={item}
      name="LATEST_NEWS"
      pagePosition="Homepage Article Carousel"
      variant="4/5-text-over"
    />
  );
}

export default function ArticleHighlightCarousel({ items }: CarouselProps) {
  return (
    <div className="py-10 md:py-20">
      <HighlightCarousel
        slides={items}
        autoSlideDuration={3000}
        scaleDown={0.2}
        hasEqualGaps
        getSlideKey={(_, index) => `article-${index}`}
        renderSlideContent={(article) => <SlideContent item={article} />}
      />
    </div>
  );
}
